import {
    GETSUBMODULENAMELIST_SUCCESS,
    GETSUBMODULENAMELIST_FAILED,
    RESET_GETSUBMODULENAMELIST,
    LOADING_GETSUBMODULENAMELIST,
    NETWORK_ERROR_GETSUBMODULENAMELIST
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_GETSUBMODULENAMELIST:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case GETSUBMODULENAMELIST_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case GETSUBMODULENAMELIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_GETSUBMODULENAMELIST:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_GETSUBMODULENAMELIST:
            return (state = initialState);
        default:
            return state;
    }
};
